enum STATUSES {
  Uploading,
  UploadErrors,
  UploadSuccess,
  Confirming,
  ConfirmSuccess,
  ConfirmErrors,
}
export default STATUSES;
